
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function CategoryListPageRT () {
    function repeatFront1(sizes, frontSizes, rearSizes, isStaggered, front, frontIndex) {
        return _createElement('div', {
            'key': front.WheelDiameter,
            'className': 'cm_category-list_sizes-group-size'
        }, _createElement('div', {}, front.TireSizes.join(', ')), _createElement('div', {}, front.WheelDiameter, '"'));
    }
    function repeatRear2(sizes, frontSizes, rearSizes, isStaggered, rear, rearIndex) {
        return _createElement('div', {
            'key': rear.WheelDiameter,
            'className': 'cm_category-list_sizes-group-size'
        }, _createElement('div', {}, rear.TireSizes.join(', ')), _createElement('div', {}, rear.WheelDiameter, '"'));
    }
    function repeatSize3(sizes, frontSizes, rearSizes, isStaggered, size, sizeIndex) {
        return _createElement('div', {
            'key': size.WheelDiameter,
            'className': 'cm_category-list_sizes-group-size'
        }, _createElement('div', {}, size.TireSizes.join(', ')), _createElement('div', {}, size.WheelDiameter, '"'));
    }
    function scopeFrontSizesRearSizesIsStaggered4(sizes) {
        var frontSizes = sizes.filter(s => s.Position === 'Front');
        var rearSizes = sizes.filter(s => s.Position === 'Rear');
        var isStaggered = frontSizes?.length > 0;
        return _createElement('div', { 'className': 'cm_category-list_sizes' }, _createElement('div', { 'className': 'cm_category-list_sizes-title' }, 'O.E. Sizes'), _createElement('div', { 'className': 'cm_category-list_sizes-groups' }, isStaggered ? [
            _createElement.apply(this, [
                'div',
                {
                    'className': 'cm_category-list_sizes-group',
                    'key': '20341'
                },
                _createElement('div', { 'className': 'cm_category-list_sizes-group-title' }, _createElement('div', {}, 'Front Tires'), _createElement('div', {}, 'Wheels')),
                _map(frontSizes, repeatFront1.bind(this, sizes, frontSizes, rearSizes, isStaggered))
            ]),
            _createElement.apply(this, [
                'div',
                {
                    'className': 'cm_category-list_sizes-group',
                    'key': '20343'
                },
                _createElement('div', { 'className': 'cm_category-list_sizes-group-title' }, _createElement('div', {}, 'Rear Tires'), _createElement('div', {}, 'Wheels')),
                _map(rearSizes, repeatRear2.bind(this, sizes, frontSizes, rearSizes, isStaggered))
            ])
        ] : null, !isStaggered ? _createElement.apply(this, [
            'div',
            {
                'className': 'cm_category-list_sizes-group',
                'key': '3042'
            },
            _createElement('div', { 'className': 'cm_category-list_sizes-group-title' }, _createElement('div', {}, 'Tires'), _createElement('div', {}, 'Wheels')),
            _map(sizes, repeatSize3.bind(this, sizes, frontSizes, rearSizes, isStaggered))
        ]) : null));
    }
    function scopeSizes5() {
        var sizes = this.responseExtra?.FormattedVehicleInfo;
        return _createElement('div', { 'className': 'cm_category-list' }, sizes ? _createElement('div', {
            'className': 'cm_category-list_info',
            'key': '94'
        }, _createElement('div', { 'className': 'cm_category-list_vehicle' }, [this.WheelTireVehicleInfo(function () {
                return _createElement('div', { 'className': 'cm_WheelTireVehicleInfo' }, [this.autoSyncVisualization(function () {
                        return _createElement('div', { 'className': 'cm_autoSyncVisualization' }, _createElement('div', { 'className': 'cm_vehicle-visualization-container' }, this.visualization));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })]);
            }, {
                widgetName: 'undefined',
                items: undefined
            })], [this.SearchVehicleWidget(function () {
                return this.isVehicleSelected ? _createElement('div', {
                    'className': 'cm_vehicle-widget cm_vehicle-widget__category-list cm_SearchVehicleWidget',
                    'key': '0'
                }, _createElement('div', { 'className': 'cm_vehicle-widget_vehicle-base' }, _createElement('span', {}, this.vehicle.Year, ' ', this.vehicle.Make), _createElement('div', {
                    'className': 'cm_vehicle-widget_edit',
                    'onClick': this.openDialog,
                    'role': 'button'
                }, 'edit')), _createElement('div', { 'className': 'cm_vehicle-widget_vehicle-extra' }, this.vehicle.Model, ' ', this.vehicle.Submodel)) : null;
            }, {
                widgetName: 'undefined',
                items: undefined
            })]), scopeFrontSizesRearSizesIsStaggered4.apply(this, [sizes])) : null, _createElement('div', { 'className': 'cm_category-list_categories' }, _createElement('h4', { 'className': 'cm_category-list_categories-title' }, 'What are you shopping for?'), [this.FacetCategoryTiles(function () {
                function repeatHierarchicalGroups1(hierarchicalGroups, hierarchicalGroupsIndex) {
                    return [hierarchicalGroups(function () {
                            return _createElement('a', {
                                'className': 'cm_category-list_tiles-tile',
                                'href': this.href
                            }, _createElement('div', { 'className': 'cm_category-list_tiles-tile_title' }, this.value), _createElement('div', { 'className': 'cm_category-list_tiles-tile_image-container' }, _createElement('img', {
                                'className': 'cm_category-list_tiles-tile_image',
                                'src': this.getImageOrDefault(this.imageUrl),
                                'alt': this.value
                            })));
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_category-list_tiles cm_FacetCategoryTiles' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_category-list_tiles-repeater cmRepeater_hierarchicalGroups' },
                    _map(this.hierarchicalGroups, repeatHierarchicalGroups1.bind(this))
                ]));
            }, {
                widgetName: 'undefined',
                items: undefined
            })]));
    }
    return scopeSizes5.apply(this, []);
}
        export const componentNames = ["cm:autoSyncVisualization","cm:WheelTireVehicleInfo","cm:SearchVehicleWidget","cm:FacetCategoryTiles"]